import { useBreakpoint } from '@ocean/hooks'
import { common } from '@ocean/ui'
import { FormControlTrace, FilterSkeletonWrapper } from '../Skeleton.styled'

const { Translucent } = common.skeletonStyles

const FilterSkeleton: React.FC = () => {
  const isDesktop = useBreakpoint('sm')

  return (
    <Translucent opacity='0.7' data-test='FilterSkeleton'>
      <FilterSkeletonWrapper>
        <FormControlTrace width={isDesktop ? '40%' : '100%'} color='greyLight' />
        {isDesktop && <FormControlTrace width='50%' color='greyLight' />}
      </FilterSkeletonWrapper>
    </Translucent>
  )
}

export default FilterSkeleton
